"use client"

import { usePlatformContext, type PlatformInfo } from '@/components/platform-provider'

export type { PlatformInfo }

/**
 * Hook to detect the current platform and environment
 * Provides precise control over Website vs iOS App logic
 */
export function usePlatform(): PlatformInfo {
  return usePlatformContext()
}

/**
 * Global helper for haptic feedback
 */
export async function triggerHaptic(type: 'impact' | 'selection' | 'notification' | 'success' | 'warning' | 'error' = 'selection') {
  try {
    const win = window as any
    if (!win.Capacitor) return

    const { Haptics, ImpactStyle, NotificationType } = await import('@capacitor/haptics')
    
    switch (type) {
      case 'impact':
        await Haptics.impact({ style: ImpactStyle.Light })
        break
      case 'selection':
        await Haptics.selectionStart()
        await Haptics.selectionChanged()
        await Haptics.selectionEnd()
        break
      case 'success':
      case 'notification':
        await Haptics.notification({ type: NotificationType.Success })
        break
      case 'warning':
        await Haptics.notification({ type: NotificationType.Warning })
        break
      case 'error':
        await Haptics.notification({ type: NotificationType.Error })
        break
    }
  } catch (e) {
    // Silent fail
  }
}
